import { Component, Injector, OnInit } from '@angular/core';

import { DialogAbstractComponent } from '../dialog.class';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent extends DialogAbstractComponent implements OnInit {
  dialogTitle;
  dialogContent;
  okText;
  cancelText;

  constructor(injector: Injector) {
    super(injector);
    this.dialogTitle = this.dialogParams.title;
    this.dialogContent = this.dialogParams.content;
    this.okText = this.dialogParams.okText;
    this.cancelText = this.dialogParams.cancelText;
  }

  ngOnInit() {}

  ok() {
    this.closeDialog('1111');
  }

  cancel() {
    this.cancelDialog(false);
  }
}
